import PollGraph from "./PollGraph";

export default PollGraph;
